import { useContext, useState } from 'react';
import { PrivilegeContext } from '../../../components/priviledge/PriviledgeProvider';
import { ContractService } from '../../../services/contract/contractService';

/*----------------------------------------------------------------------------------------
* EN: Hook to manage contract fetching and transformation logic.
* ES: Hook para gestionar la lógica de obtención y transformación de contratos.
----------------------------------------------------------------------------------------*/

const useContract = (initialFilters = {}, withPermission = false) => {

    const { userCan } = useContext(PrivilegeContext);
    const [data, setData] = useState<any[]>([]);
    const filters = {
        limit: 200,
        filter_filters: { ...initialFilters }
    };

    const fetchContracts = async (f?: any) => {
        if (withPermission && !userCan('list_contracts', 'contracts') && !userCan('admin_contracts', 'contracts')) return [];
        const newFilters = { ...filters, filter_filters: { ...filters.filter_filters, ...f } };
        try {
            const response = await (new ContractService()).listContracts(newFilters);
            const fetchedData = response.getResponseData()?.data;

            if (fetchedData && fetchedData?.data) {
                const mappedData = fetchedData.data?.map((data: { id: string; code: string; }) => ({
                    value: data.id,
                    label: data.code,
                }));
                setData(mappedData);
                return mappedData;
            }
        } catch (error) {
            console.log('Error fetching contracts:', error);
        }
        return [];
    };

    const getContractsList = () => {
        return data;
    };

    return { fetchContracts, getContractsList };
}

export default useContract;